import { Button, Modal, message, Tag, Flex } from 'antd'
import { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import dayjs from '../../lib/datetime'
import { processCycle, useCycle } from '../../redux/slices/practices'
import Loading from '../Loading'

export default function GenerateBillingOrdersButton({ cycleId }) {
  const cycle = useCycle(cycleId)
  const hasBeenCalled = !!cycle.preAuthProcessedAt
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const handleGenerate = useCallback(async () => {
    try {
      setLoading(true)
      await dispatch(processCycle(cycleId))
      message.success('Missed transmissions have been generated')
    } catch (e) {
      message.error(
        `There was an error generating missed transmissions: ${e.message}`,
      )
    }
    setLoading(false)
  }, [cycleId, dispatch])
  return (
    <>
      <Button
        onClick={handleGenerate}
        type={hasBeenCalled ? 'default' : 'primary'}
      >
        Generate missed transmissions
      </Button>
      {hasBeenCalled && (
        <Flex align="center">
          Last time called:&nbsp;
          <Tag color="cyan">{dayjs(cycle.preAuthProcessedAt).fromNow()}</Tag>
        </Flex>
      )}
      <Modal
        maskClosable={false}
        footer={null}
        closable={false}
        title="Generating missing transmissions..."
        open={loading}
      >
        <Loading large />
      </Modal>
    </>
  )
}

GenerateBillingOrdersButton.propTypes = {
  cycleId: PropTypes.string.isRequired,
}
